<lvr-simple-panel>
	@if (!person()) {
		<span title>{{ 'institution.persons.persons' | transloco }}</span>
	} @else {
		<span title>{{ person()?.title }} {{ personName() }}</span>
	}
	<div content>
		@if (!person()) {
			{{ 'institution.persons.no_persons' | transloco: { name: institutionName() } }}
		} @else {
			<table>
				<tr>
					<th scope="col">{{ 'base.field.gender' | transloco }}</th>
					<th scope="col">{{ 'base.field.category' | transloco }}</th>
					<th scope="col">{{ 'base.field.contact_point.title' | transloco }}</th>
				</tr>
				<tr>
					<td>
						{{ this.person()?.gender?.salutation }}
					</td>
					<td>{{ person()?.personType?.name }}</td>
					<td>
						<ul>
							@for (contactPoint of person()?.contactPoints; track contactPoint.id) {
								<li>
									{{ contactPoint.contactValue }}<br />
									{{ contactPoint.remark }}
								</li>
							}
						</ul>
					</td>
				</tr>
			</table>
		}
	</div>
</lvr-simple-panel>
